import appStoreBadge from '../assets/badges/badge-appstore.svg';
import googlePlayBadge from '../assets/badges/badge-googleplay.svg';

export default function AppStoreBadge({
  appStoreHref = 'https://apps.apple.com/us/app/ripple-number-puzzle/id6767247130',
  googlePlayHref = 'https://play.google.com/store/apps/details?id=com.ripple.app.mobile',
}) {
  return (
    <div className="store-badges">
      <a
        href={appStoreHref}
        className="store-badge-link"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download on the App Store"
      >
        <img src={appStoreBadge} alt="" width="180" height="54" />
      </a>
      <a
        href={googlePlayHref}
        className="store-badge-link"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get it on Google Play"
      >
        <img src={googlePlayBadge} alt="" width="180" height="54" />
      </a>
    </div>
  );
}
